const SettingsSections = {
    SECURITY: 'security',
    PREFERENCES: 'preferences',
    USERS: 'users',
    ORGANIZATIONS: 'organizations',
    LMS: 'lms',
}

export default SettingsSections
